declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, MaterialsListController, MaterialsListRequest, SavePurchaseOrderRequest, S_Methods, PurchaseIndentItemsController, PurchaseIndentItemsRequest, PurchaseIndentItemsInfoController, PurchaseIndentsListController, PurchaseOrderItemRequest, PurchaseOrderDetailsInfoController, PurchaseOrdersListController, VendorsListController, SaveDoccumentStateRequest, GenericProcPostRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';
import { NgbSearchVendorsModal } from './modal/searchvendors.modal';
import { NgbEditPOitemsModal } from './modal/editPOitems.modal';





@Component({
  selector: 'purchaseorderadd',
  templateUrl: './purchaseorderadd.component.html',
  styleUrls: ['./purchaseorderadd.component.scss']
  , animations: [routerTransition()]
})

export class PurchaseOrderAddComponent implements OnInit {


  public ApiResData: ApiResponseModel;

  public ActorCode: number = 0;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
    public searchValue: string;
  public isvisible: boolean = true;
  public BranchName: string;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  public DocIDdata: string;
  public VendorCode: any;
  public VendorName: any;
  public VendorContact: any;
  public UnitPrice: number;
  public TaxPercent: number;
  public ItemTax: number;
  public Quantity: number;
  public BonusQuantity: number = 0;
  public TotalOrderQuantity: number;
  public UomName: string;
  public Mrp: number;
  public Pack: number;
  public PurchasePrice: number;
  public SalePrice: number;
  public TermsAndConditions: string = "";
  searchTitle: string;
  isRequesting: boolean;
    MfgDate: NgbDateStruct;
  ExpDate: NgbDateStruct;
  PostingDate: NgbDateStruct;
  DeliveryDate: NgbDateStruct;
  TodayDate = new Date();
  CurrentSavePurchaseOrderRequest: SavePurchaseOrderRequest;

  CurrentPurchaseIndentsHeaderController: PurchaseIndentsListController;
  CurrentPurchaseIndentItemsController: PurchaseIndentItemsController[];
  CurrentPurchaseIndentItemsRequest: PurchaseIndentItemsRequest;
  PurchaseIndentDataHeader: PurchaseIndentItemsInfoController;

  //header + items
  PurchaseOrderData: SavePurchaseOrderRequest;

  LoadItems() {
    this.CurrentPurchaseIndentItemsRequest = new PurchaseIndentItemsRequest();
    this.CurrentPurchaseIndentItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseIndentItemsController();
  }
  CopyIndentToPurchaseOrder() {
    this.PurchaseOrderData.HasIndent = true;
    this.PurchaseOrderData.IndentFormattedCode = this.CurrentPurchaseIndentsHeaderController.IndentNo;
    this.PurchaseOrderData.OrderStatus = this.CurrentPurchaseIndentsHeaderController.IndentStatus;
    this.PurchaseOrderData.ShipToLocation = parseInt(this.CurrentPurchaseIndentsHeaderController.FromStoreLocation);
    this.PurchaseOrderData.OwnerStoreName = this.CurrentPurchaseIndentsHeaderController.FromStoreName;
    this.PurchaseOrderData.PayInDays = 10;
    this.PurchaseOrderData.PurchaseOrderCode = 0;
    //this.PurchaseOrderData.SupplierRef = this.CurrentPurchaseIndentsHeaderController;
    //this.PurchaseOrderData.SupplierName = "MY SELF";
    this.PurchaseOrderData.Items = new Array<PurchaseOrderItemRequest>();
    for (var i = 0; i < this.CurrentPurchaseIndentItemsController.length ;i ++){
      var poItem = new PurchaseOrderItemRequest();
      var indentItem = this.CurrentPurchaseIndentItemsController[i];

      poItem.ItemCode = indentItem.MaterialCode;
      poItem.ItemDescription = indentItem.MaterialDescription;
      poItem.Quantity = indentItem.Quantity;
      //poItem.TotalOrderQuantity = indentItem.OrderQuantity;
      poItem.UomName = indentItem.UOM;
      poItem.UnitPrice = this.UnitPrice;
      poItem.TaxPercent = this.TaxPercent;
      poItem.Tax = this.ItemTax;
      //poItem.Quantity = this.OrderQuantity;
      poItem.BonusQuantity = this.BonusQuantity;
      poItem.TotalOrderQuantity = this.TotalOrderQuantity;
      //poItem.UomName = this.UomName;
      poItem.Mrp = this.Mrp;
      poItem.Pack = this.Pack;
      poItem.PurchasePrice = this.PurchasePrice;
      poItem.SalePrice = this.SalePrice;

        this.PurchaseOrderData.Items.push(poItem);

    }

  }
  GetPurchaseIndentItemsController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentItemsRequest.DOCID = this.DocIDdata;
    this.CurrentPurchaseIndentItemsRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentItemsController(this.CurrentPurchaseIndentItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPurchaseIndentItemsController = this.ApiResData.Result;
          this.PurchaseIndentDataHeader = this.ApiResData.Result;
          this.PurchaseOrderData = new SavePurchaseOrderRequest();
          this.CurrentPurchaseIndentItemsController = this.PurchaseIndentDataHeader.PurchaseItems;
          this.CurrentPurchaseIndentsHeaderController = this.PurchaseIndentDataHeader.PurchaseHeader;
          
          this.stopRefreshing();
          //alert(this.CurrentPurchaseIndentsHeaderController.IndentNo);
          this.CopyIndentToPurchaseOrder();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.DocIDdata = this.route.snapshot.paramMap.get('DocIDdata');
    this.CurrentSavePurchaseOrderRequest = new SavePurchaseOrderRequest();
    this.CurrentSavePurchaseOrderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadItems();
    this.TermsAndConditions = AppData.Instance().cas.Terms_Conditions;
    //alert(this.TermsAndConditions);
    this.PostingDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate()
    };
    this.DeliveryDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate() + 15
    };
      
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CurrentOrderDetails: Array<PurchaseOrderItemRequest>;
  AddRow(l: PurchaseIndentItemsController) {
    if (this.CurrentOrderDetails == null) {
      this.CurrentOrderDetails = new Array<PurchaseOrderItemRequest>();

    }
    var itemExists = this.CurrentOrderDetails.find(x => x.ItemCode == l.MaterialCode);
    if (itemExists != null) {
      return;
    }
    else {
      var row = new PurchaseOrderItemRequest();
      row.ItemCode = l.MaterialCode;
      row.ItemDescription = l.MaterialDescription;
      row.PurchaseOrderItemCode = 0;
      row.Quantity = 1;
      row.UomName = l.UOM;

      this.CurrentOrderDetails.push(row);
    }

  }
  SaveData() {
    this.spinner.show();
    this.CurrentSavePurchaseOrderRequest.OwnerName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePurchaseOrderRequest.OwnerLocation = AppData.Instance().SelectedBranchCode;
    this.CurrentSavePurchaseOrderRequest.PostingDate = new Date(this.parserFormatter.format(this.PostingDate));
    this.CurrentSavePurchaseOrderRequest.DeliveryDate = new Date(this.parserFormatter.format(this.DeliveryDate));
    this.CurrentSavePurchaseOrderRequest.SupplierCode = this.VendorCode;
    this.CurrentSavePurchaseOrderRequest.SupplierName = this.VendorName;
    this.CurrentSavePurchaseOrderRequest.SupplierContactPersonCode = this.VendorContact;
    this.CurrentSavePurchaseOrderRequest.RefDetails = this.PurchaseOrderData.RefDetails;
    this.CurrentSavePurchaseOrderRequest.PurchaseOrderCode = this.PurchaseOrderData.PurchaseOrderCode;
    this.CurrentSavePurchaseOrderRequest.OrderStatus = this.PurchaseOrderData.OrderStatus;
    this.CurrentSavePurchaseOrderRequest.PayInDays = this.PurchaseOrderData.PayInDays;
    this.CurrentSavePurchaseOrderRequest.PayAgainst = 'GRN';
    //this.CurrentSavePurchaseOrderRequest.PayAgainst = this.PurchaseOrderData.PayAgainst;
    this.CurrentSavePurchaseOrderRequest.ShipToLocation = this.PurchaseOrderData.ShipToLocation;
    this.CurrentSavePurchaseOrderRequest.ConditionalOperator = 10;
    this.CurrentSavePurchaseOrderRequest.Items = this.PurchaseOrderData.Items;
    this.CurrentSavePurchaseOrderRequest.Tax = this.PurchaseOrderData.Tax;
    this.CurrentSavePurchaseOrderRequest.TotalBeforeTax = this.PurchaseOrderData.TotalBeforeTax;
    this.CurrentSavePurchaseOrderRequest.GrandTotal = this.PurchaseOrderData.GrandTotal;
    this.CurrentSavePurchaseOrderRequest.Terms = this.TermsAndConditions;
    this.CurrentSavePurchaseOrderRequest.IndentFormattedCode = this.PurchaseOrderData.IndentFormattedCode;
    this.actorservice.Save<SavePurchaseOrderRequest>(
      this.CurrentSavePurchaseOrderRequest, S_Methods.SavePurchaseOrders
    )
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }


  public istextshow: boolean = false;

  Cancel() {
    this.router.navigate(['healins/purchaseorder']);
  }
  opbill() {

  }
  SelectVendor() {
    const modalRef = this.modalService.open(NgbSearchVendorsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((l: VendorsListController) => {      
      this.VendorCode = l.VendorCode;
      this.VendorName = l.DisplayName;
      this.VendorContact = l.Telephone1;
    });
  }
  EditItems(PurchaseOrderData: SavePurchaseOrderRequest, input: PurchaseOrderItemRequest) {
    const modalRef = this.modalService.open(NgbEditPOitemsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PurchaseOrderItem = input;
    modalRef.componentInstance.PurchaseOrderData = PurchaseOrderData;
    modalRef.componentInstance.VendorName = this.VendorName;
    modalRef.componentInstance.VendorCode = this.VendorCode;
    modalRef.result.then((l: PurchaseOrderItemRequest) => {
      input.UnitPrice = (l.PurchasePrice) / (l.Quantity * l.Pack);
      input.TotalOrderQuantity = l.Quantity + l.BonusQuantity;
      input.BonusQuantity = l.BonusQuantity;
      input.TaxPercent = l.TaxPercent;
      
      input.Quantity = l.Quantity;
       
  
    
      input.UomName = l.UomName;
      input.Mrp = l.Mrp;
      input.Pack = l.Pack;
      input.PurchasePrice = l.PurchasePrice;
      //input.SalePrice = l.SalePrice;

      input.Tax = (l.Quantity * l.PurchasePrice * l.TaxPercent) / 100;
      input.ItemTotal = l.Quantity * l.PurchasePrice;
      input.ItemNet = input.ItemTotal + input.Tax; 
      this.CalculateTotals();
    });
  }
  CalculateTotals() {
    //alert(this.CurrentOrderDetails.length);
    this.PurchaseOrderData.Tax = this.PurchaseOrderData.Items.filter((item) => item.Tax)
      .map((item) => +item.Tax)
      .reduce((sum, current) => sum + current);

    this.PurchaseOrderData.TotalBeforeTax = this.PurchaseOrderData.Items.filter((item) => item.PurchasePrice)
      .map((item) => item.Quantity * item.PurchasePrice)
      .reduce((sum, current) => sum + current);//-- * this.PurchaseOrderData.Items.filter((item) => item.Quantity)
      //.map((item) => +item.Quantity)
      //  .reduce((sum, current) => sum + current);
    this.PurchaseOrderData.GrandTotal = this.PurchaseOrderData.TotalBeforeTax  + this.PurchaseOrderData.Tax;

    //alert(this.PurchaseOrderData.Tax);
    //this.CurrentOrderDetails.f
    //this.PurchaseOrderData.TotalBeforeTax += 1;
    //this.PurchaseOrderData.DiscountAmount += 1;
    //this.PurchaseOrderData.Tax += 1;
    //this.PurchaseOrderData.GrandTotal += 1;
    //this.PurchaseOrderData.TotalBeforeTax += 1;
    //this.PurchaseOrderData.DiscountAmount += 1;
    //this.PurchaseOrderData.Tax += 1;
    //this.PurchaseOrderData.GrandTotal += 1;
       


}
  ShipToLocation: number = 0;
  public ShipToLocationname: string;
  onAssignedShipToLocationname(event: any) {
    if (event != null) {
      this.ShipToLocationname = event;
     // this.StoreItems();
    }
  }
  StoreList_loaded(e: any) {

  }

}


